import { render, staticRenderFns } from "./unicomDeal6.vue?vue&type=template&id=6a834176&scoped=true"
import script from "./unicomDeal6.vue?vue&type=script&lang=js"
export * from "./unicomDeal6.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal6.vue?vue&type=style&index=0&id=6a834176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a834176",
  null
  
)

export default component.exports